import { render, staticRenderFns } from "./EnviarEstudio.vue?vue&type=template&id=15b2b1f6&"
import script from "./EnviarEstudio.vue?vue&type=script&lang=js&"
export * from "./EnviarEstudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports